(() => {
  const updateCountdowns = () => {
    document.querySelectorAll('[data-corde-countdown]').forEach((element) => {
      const end = Date.parse(element.dataset.end || document.documentElement.dataset.cordeDealEnd || '');
      const wrapper = element.closest('[data-corde-countdown-wrap]');

      if (!Number.isFinite(end)) {
        if (wrapper) wrapper.hidden = true;
        return;
      }

      const remaining = end - Date.now();
      if (remaining <= 0) {
        element.textContent = 'Offer ended';
        if (wrapper) wrapper.dataset.expired = 'true';
        return;
      }

      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);
      element.textContent = `${days}d ${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m ${String(seconds).padStart(2, '0')}s`;
      element.setAttribute('datetime', new Date(end).toISOString());
    });
  };

  updateCountdowns();
  window.setInterval(updateCountdowns, 1000);
  document.addEventListener('shopify:section:load', updateCountdowns);
})();
